// ##### 25-05-21 Komarov
import React from 'react';

const MapDotRequest = () => (
  <svg
    version="1.0"
    //    width="678.29364pt"
    //    height="514.27875pt"
    width="25"
    height="20"
    // viewBox="0 0 678.29364 514.27875"
    viewBox="0 0 707.77069 511.04553"
    preserveAspectRatio="xMidYMid"
    id="svg12"
    sodipodi:docname="City_Quest_01.svg"
    inkscape:version="1.3 (0e150ed6c4, 2023-07-21)"
    xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
    xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:svg="http://www.w3.org/2000/svg"
  >
    <defs id="defs12" />
    <sodipodi:namedview
      id="namedview12"
      pagecolor="#ffffff"
      bordercolor="#000000"
      borderopacity="0.25"
      inkscape:showpageshadow="2"
      inkscape:pageopacity="0.0"
      inkscape:pagecheckerboard="0"
      inkscape:deskcolor="#d1d1d1"
      inkscape:document-units="pt"
      inkscape:zoom="0.74560547"
      inkscape:cx="470.75835"
      inkscape:cy="339.99214"
      inkscape:window-width="1366"
      inkscape:window-height="705"
      inkscape:window-x="-8"
      inkscape:window-y="-8"
      inkscape:window-maximized="1"
      inkscape:current-layer="svg12"
    />
    <g
      transform="matrix(0.1,0,0,-0.1,-2,512)"
      fill="#000000"
      stroke="none"
      id="g12"
      style={{
        fill: '#5599ff',
      }}
    >
      <path
        d="M 97,5098 C 74,5084 52,5060 40,5035 20,4994 20,4970 20,2560 20,147 20,126 40,85 53,59 74,36 99,22 L 138,0 h 2422 2422 l 39,22 c 25,14 46,37 59,63 20,41 20,57 18,1778 -3,1735 -3,1736 -24,1763 -11,15 -33,37 -48,48 -27,21 -31,21 -1236,21 H 2581 l -28,-21 c -15,-12 -37,-36 -48,-55 -20,-33 -20,-54 -23,-1066 l -2,-1033 h -160 -160 v 1482 c 0,1468 0,1482 -20,1524 -15,29 -33,48 -63,63 -51,26 -1873,531 -1913,531 -16,0 -46,-10 -67,-22 z m 1015,-545 748,-208 V 2933 1520 h -247 c -277,0 -297,-4 -340,-69 l -23,-34 V 859 300 H 785 320 v 2236 2236 l 23,-6 c 12,-3 358,-99 769,-213 z M 4800,1850 V 300 h -275 -275 v 261 c 0,247 -1,263 -21,299 -43,76 -40,75 -441,75 -345,0 -357,-1 -384,-21 -15,-11 -37,-33 -48,-48 -20,-26 -21,-43 -24,-297 l -3,-269 h -189 -190 v 545 c 0,438 -3,552 -14,578 -18,45 -70,86 -117,93 l -39,7 v 932 c 0,512 3,935 7,938 3,4 458,7 1010,7 H 4800 Z M 2650,760 V 300 h -200 -200 v 88 c 0,111 -12,153 -55,191 -46,40 -93,48 -150,26 -74,-28 -89,-60 -93,-193 l -4,-112 h -199 -199 v 460 460 h 550 550 z M 3950,470 V 300 h -160 -160 v 170 170 h 160 160 z"
        id="path1"
        style={{
          fill: '#5599ff',
        }}
      />
      <path
        d="m 710,4078 c -54,-37 -74,-72 -74,-128 0,-54 18,-87 68,-124 26,-20 42,-21 371,-24 384,-3 391,-2 441,63 22,29 28,48 28,86 0,55 -20,90 -74,127 -33,22 -37,22 -380,22 -343,0 -347,0 -380,-22 z"
        id="path2"
        style={{
          fill: '#5599ff',
        }}
      />
      <path
        d="m 724,3476 c -52,-23 -88,-79 -88,-137 0,-55 20,-90 74,-126 33,-23 37,-23 377,-23 375,0 376,0 426,59 38,45 43,94 15,149 -45,89 -32,87 -426,89 -277,2 -353,0 -378,-11 z"
        id="path3"
        style={{
          fill: '#5599ff',
        }}
      />
      <path
        d="m 737,2866 c -51,-19 -67,-34 -89,-84 -30,-67 -6,-143 55,-181 33,-20 46,-21 387,-21 317,0 355,2 382,18 95,56 94,200 -2,257 -33,19 -53,20 -365,22 -259,2 -338,0 -368,-11 z"
        id="path4"
        style={{
          fill: '#5599ff',
        }}
      />
      <path
        d="m 713,2244 c -38,-19 -69,-64 -78,-114 -9,-54 28,-119 85,-147 43,-22 52,-23 370,-23 318,0 327,1 370,23 84,41 109,133 59,213 -38,62 -50,64 -431,64 -294,0 -348,-3 -375,-16 z"
        id="path5"
        style={{
          fill: '#5599ff',
        }}
      />
      <path
        d="m 3237,3076 c -52,-19 -85,-52 -98,-97 -21,-69 9,-142 71,-174 45,-23 311,-21 352,3 94,55 91,207 -5,259 -44,24 -265,30 -320,9 z"
        id="path6"
        style={{
          fill: '#5599ff',
        }}
      />
      <path
        d="m 4062,3081 c -92,-24 -141,-139 -92,-219 40,-66 66,-73 242,-70 151,3 157,4 183,28 79,74 72,177 -18,244 -24,18 -44,21 -155,23 -70,1 -142,-2 -160,-6 z"
        id="path7"
        style={{
          fill: '#5599ff',
        }}
      />
      <path
        d="m 3214,2456 c -74,-33 -106,-149 -58,-212 46,-63 64,-69 209,-72 116,-3 139,-1 178,16 100,44 121,163 43,241 l -36,36 -153,2 c -112,2 -160,-1 -183,-11 z"
        id="path8"
        style={{
          fill: '#5599ff',
        }}
      />
      <path
        d="m 4022,2450 c -99,-61 -95,-203 8,-257 38,-20 57,-23 168,-23 105,0 132,3 167,20 106,51 113,199 13,260 -29,17 -51,20 -178,20 -127,0 -149,-3 -178,-20 z"
        id="path9"
        style={{
          fill: '#5599ff',
        }}
      />
      <path
        d="m 3207,1838 c -39,-23 -77,-86 -77,-128 0,-48 39,-108 84,-129 36,-18 61,-21 172,-21 147,0 183,11 221,69 48,71 20,175 -57,213 -28,15 -61,18 -170,18 -120,0 -139,-3 -173,-22 z"
        id="path10"
        style={{
          fill: '#5599ff',
        }}
      />
      <path
        d="m 4031,1842 c -55,-27 -76,-64 -76,-132 0,-67 20,-102 75,-131 51,-28 289,-28 340,0 55,29 75,64 75,131 0,67 -20,102 -75,131 -49,27 -288,28 -339,1 z"
        id="path11"
        style={{
          fill: '#5599ff',
        }}
      />
      <path
        d="m 3715,5113 c -130,-29 -232,-90 -316,-190 l -25,-30 -70,14 c -220,46 -440,-100 -490,-325 -15,-66 -15,-87 -5,-147 30,-178 157,-314 327,-350 100,-21 1147,-22 1247,0 91,19 160,58 233,130 145,144 176,365 77,546 -34,63 -119,148 -181,182 -91,49 -224,69 -317,48 -24,-6 -39,-1 -75,25 -66,46 -122,72 -192,89 -59,14 -169,18 -213,8 z m 160,-304 c 28,-8 60,-31 104,-75 80,-81 122,-96 190,-70 119,46 166,46 222,-1 84,-71 77,-201 -14,-261 l -41,-27 h -575 c -644,0 -610,-4 -646,72 -22,46 -13,93 25,131 53,54 117,51 181,-9 23,-21 57,-43 76,-50 79,-26 162,25 188,115 20,66 45,108 87,139 61,45 126,57 203,36 z"
        id="path12"
        style={{
          fill: '#5599ff',
        }}
      />
    </g>
    <g
      transform="matrix(0.38488971,0,0,-0.38488971,-419.03818,629.51716)"
      fill="#000000"
      stroke="none"
      id="g2"
      style={{
        fill: '#ff7300',
        fillOpacity: 1,
      }}
    >
      <path
        d="m 2553.5406,893.89103 c -9.023,0.029 -18.0176,-0.3379 -26.9532,-1.0986 -8.9355,-0.7608 -17.8091,-1.9212 -26.6015,-3.4571 -8.7925,-1.5358 -17.4952,-3.4453 -26.0889,-5.7421 -8.5937,-2.2969 -17.0757,-4.969 -25.415,-8.0127 -8.3394,-3.0437 -16.5362,-6.4629 -24.5655,-10.2393 -8.0293,-3.7764 -15.8911,-7.9124 -23.5546,-12.4072 -7.6636,-4.4949 -15.126,-9.3467 -22.3682,-14.5459 -7.2422,-5.1992 -14.27,-10.7512 -21.0352,-16.6406 -6.7651,-5.8894 -13.2793,-12.1114 -19.5117,-18.6768 -6.2324,-6.5654 -12.1831,-13.471 -17.8271,-20.6982 -5.6441,-7.2273 -10.9815,-14.7862 -15.9815,-22.6612 -3.0312,-4.75 -5.9068,-9.548 -8.6426,-14.3847 -2.7358,-4.8367 -5.3204,-9.706 -7.7636,-14.6192 -2.4433,-4.9132 -4.7459,-9.8593 -6.8994,-14.8389 -2.1536,-4.9795 -4.1685,-9.9936 -6.0352,-15.0292 -1.8667,-5.0357 -3.5882,-10.0943 -5.1709,-15.1758 -1.5827,-5.0816 -3.0197,-10.1903 -4.3213,-15.3076 -2.6033,-10.2347 -4.6562,-20.5333 -6.1523,-30.84966 -1.4961,-10.3164 -2.4446,-20.65016 -2.8565,-30.9668 -0.4118,-10.31664 -0.2832,-20.61427 0.3662,-30.84961 0.6494,-10.23534 1.8279,-20.4109 3.5157,-30.4834 1.6877,-10.0725 3.8886,-20.04005 6.5918,-29.86816 2.7031,-9.82812 5.8991,-19.51637 9.5947,-29.01856 3.6955,-9.50218 7.8887,-18.81055 12.5537,-27.90527 4.665,-9.09472 9.8132,-17.96656 15.4248,-26.57227 5.6116,-8.6057 11.6875,-16.95508 18.2227,-24.99023 6.5351,-8.03515 13.5261,-15.76148 20.9619,-23.14453 3.7179,-3.69153 7.5456,-7.29734 11.4843,-10.81055 3.9388,-3.51321 7.9869,-6.9292 12.1436,-10.2539 4.1567,-3.32471 8.4162,-6.55662 12.7881,-9.68262 4.3718,-3.126 8.8631,-6.15027 13.4472,-9.06738 4.5841,-2.91712 9.2691,-5.72483 14.0625,-8.42286 4.7935,-2.69802 9.6924,-5.28027 14.6924,-7.74902 7.25,-3.5625 14.6504,-6.80103 22.1778,-9.69726 7.5273,-2.89624 15.1748,-5.44923 22.9248,-7.69043 7.75,-2.24121 15.6074,-4.15943 23.5254,-5.75684 7.9179,-1.59741 15.9043,-2.8877 23.9355,-3.85254 8.0312,-0.96484 16.0947,-1.60474 24.1846,-1.94824 8.0898,-0.34351 16.208,-0.38379 24.3017,-0.11719 8.0938,0.2666 16.1709,0.83374 24.2139,1.69922 8.043,0.86548 16.042,2.0332 23.9795,3.48633 7.9375,1.45312 15.8066,3.19995 23.584,5.22949 7.7773,2.02954 15.4648,4.33399 23.0273,6.92871 7.5625,2.59473 15.002,5.47925 22.2949,8.62793 7.293,3.14868 14.4473,6.5625 21.4161,10.25391 6.9687,3.6914 13.7568,7.65698 20.3466,11.87988 6.5899,4.2229 12.9747,8.70411 19.1309,13.44727 6.1562,4.74315 12.0859,9.7478 17.7539,15 5.668,5.25219 11.0762,10.75879 16.2012,16.50878 6.625,7.625 12.7519,15.18654 18.3984,22.74903 5.6465,7.56249 10.8164,15.12403 15.5274,22.74902 4.7109,7.62499 8.955,15.30274 12.7734,23.11524 3.8184,7.81249 7.2119,15.75196 10.1807,23.87695 2.9687,8.12499 5.5136,16.44239 7.6757,25.00488 2.1621,8.56249 3.9336,17.37403 5.3321,26.49903 1.3984,9.12499 2.4277,18.56153 3.1054,28.37402 0.6778,9.81249 1.0108,20.00489 1.0108,30.62988 0,7.62499 -0.2234,15.13404 -0.6592,22.5293 -0.4358,7.39525 -1.0947,14.667 -1.9629,21.82617 -0.8682,7.15918 -1.9402,14.20628 -3.2373,21.12308 -1.2971,6.9167 -2.8184,13.708 -4.541,20.3759 -1.7227,6.668 -3.656,13.2161 -5.8008,19.629 -2.1448,6.4128 -4.4971,12.6865 -7.0605,18.8378 -2.5635,6.1514 -5.3416,12.178 -8.3203,18.0616 -2.9788,5.8835 -6.1602,11.6318 -9.5508,17.2412 -3.3907,5.6093 -6.9822,11.0774 -10.7813,16.4062 -3.799,5.3289 -7.8076,10.5147 -12.0117,15.5567 -4.2041,5.042 -8.6072,9.9436 -13.2129,14.6924 -4.6057,4.7487 -9.4102,9.3496 -14.4141,13.7988 -5.0039,4.4492 -10.2019,8.7473 -15.6005,12.8906 -5.3987,4.1433 -10.9971,8.1221 -16.7871,11.9531 -5.7901,3.8311 -11.7811,7.5179 -17.959,11.0303 -6.178,3.5125 -12.5391,6.8613 -19.1016,10.0488 -8.625,4.1875 -17.3608,7.9373 -26.1768,11.2647 -8.8159,3.3274 -17.7089,6.2344 -26.6601,8.7158 -8.9512,2.4814 -17.9663,4.532 -26.9971,6.1816 -9.0307,1.6497 -18.0889,2.8887 -27.1435,3.7207 -9.0547,0.8321 -18.106,1.2605 -27.1289,1.2891 z"
        style={{
          fill: '#ff7300',
          fillOpacity: 1,
          stroke: 'none',
          strokeOpacity: 1,
        }}
        id="path4-4"
      />
    </g>
  </svg>
);

export default MapDotRequest;
